



































import { defineComponent, ref } from '@vue/composition-api'
import { AnslSelectionButton } from '@/components/common'

export default defineComponent({
  components: {
    AnslSelectionButton
  },
  props: {
    value: Boolean,
    deliveryStartDate: String,
    deliveryEndDate: String
  },
  model: {
    event: 'change',
    prop: 'value'
  },
  setup ({ value }, { emit }) {
    const handleSelection = (val: boolean) => {
      emit('change', val)
    }
    const internalValue = ref(value)

    return {
      handleSelection,
      internalValue
    }
  }
})
